import type {FormControlNotification} from "@ha/formhandler";
import type {Issue} from "../../../domain/entities/issue.entity";

/** The payload every milestone control of the project dialog is built with. */
function isMilestonePayload(payload: unknown): payload is {milestone: Issue} {
    return typeof payload === `object` && payload !== null && `milestone` in payload;
}

/**
 * The milestones the user removed in the project dialog, read from its change log
 * (form path without the form name -> last notification for that path).
 *
 * Only paths of the form `milestones.<uid>` name a milestone. Switching a milestone to a single
 * day removes its `end` field, which the form also reports as `childFormControl.deleted`, under
 * `milestones.<uid>.end` and without a milestone payload; that is not a deleted milestone.
 */
export function deletedMilestones(changedValues: Iterable<[string, FormControlNotification]>): Issue[] {
    const milestones: Issue[] = [];
    for (const [key, notification] of changedValues) {
        const segments = key.split(`.`);
        const payload = notification.formControl?.payload;
        if (segments.length === 2 && segments[0] === `milestones`
            && notification.event === `childFormControl.deleted` && isMilestonePayload(payload)) {
            milestones.push(payload.milestone);
        }
    }
    return milestones;
}
